import { InjectionToken } from '@angular/core';
import { EcwidModel } from '@boxx/store-core/lib/models/Ecwid.model';
import { Observable } from 'rxjs';
import { BusinessModel } from '../models/BusinessConfig.model';
import {
  BusinessUpdateApiRespProps,
  BusinessUpdatePayloadProps,
  IDeleteImageFormProps,
  IDeleteImageResponse,
  IGetBusinessImagesApiRespoProps,
  ISearchClientResponse,
  IWizardCreateUserPayloadProps,
  IWizardUserBusinessAdditionalInfoResponse,
  IWizardUserBusinessInfoResponse,
  IWizardUserPersonalInfoResponse,
  WizardGetTemplatesApiRespProps,
} from '../repositories/IOnboarding.api';
import {
  IBusinessUpdateInfoPayload,
  IImageFormProps,
  IRatingAppProps,
  ITokenEcwid,
  UpdateMetaPayloadProps,
} from '../repositories/IOnboarding.repository';

export interface IOnboardingService {
  getBusinessData(): Observable<BusinessModel>;

  getTemplates(query: string): Observable<WizardGetTemplatesApiRespProps>;

  getImagesData(): Observable<IGetBusinessImagesApiRespoProps>;

  deleteBusinessImage(
    payload: IDeleteImageFormProps
  ): Observable<IDeleteImageResponse>;

  uploadImageData(payload: IImageFormProps): Promise<any>;

  getUploadImagesUrl(): string;

  // ------------- REGISTRATION -------------
  saveUserData(
    payload: IWizardCreateUserPayloadProps
  ): Observable<{ token: string; brand: any }>;

  // ------------- BUSINESS CONFIG -------------

  updateBusinessData(
    businessData: BusinessUpdatePayloadProps
  ): Observable<BusinessModel>;

  updateBusinessInfoData(
    businessInfoData: IBusinessUpdateInfoPayload
  ): Observable<BusinessModel>;

  createWebsite(): Observable<BusinessUpdateApiRespProps>;

  updateMeta(payload: UpdateMetaPayloadProps): Promise<BusinessModel>;

  //------ UTILS -------
  getWizardUserPersonalInfo(
    businessId: number
  ): Observable<IWizardUserPersonalInfoResponse>;
  getWizardBusinessInfo(
    businessId: number
  ): Observable<IWizardUserBusinessInfoResponse>;
  getWizardBusinessAdditionalInfo(
    businessId: number
  ): Observable<IWizardUserBusinessAdditionalInfoResponse>;
  searchClient(email: string): Observable<{
    businessData: ISearchClientResponse | undefined;
    meta?: any;
  }>;

  //-----ECWID STORE STATUS --------
  setTokenEcwid(payload: ITokenEcwid): Observable<EcwidModel>;

  saveScoreData(
    scoreData: IRatingAppProps): Observable<any>;
}

export const ONBOARDING_SERVICE = new InjectionToken<IOnboardingService>(
  'OnboardingService'
);

export const BUSINESS_ID_KEY = 'business_id';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type WEBSITE_STATUS = 'NO_PAGE' | 'CREATED' | 'SUSPENDED';
